<template>
    <div class="index-page">
        <div
            class="navbar navbar-expand-md bsnav bsnav-transparent bsnav-brand-center bsnav-scrollspy bsnav-sticky bsnav-sticky-slide">
            <b-dropdown right class="lang_mob">
                <template slot="button-content">
                    <div class="lang_icon"></div>
                    <!--                            <img src="/static/images/icons/language.svg" class="d-inline-block align-top" width="26" style="margin-top: -1px" alt="Kitten">-->
                    <b class="lang_suffix">{{ selectedLocale.suffix.toUpperCase() }}</b>
                </template>
                <b-dropdown-item v-for="language in languages" :key="language.name" @click="changeLanguage(language)">{{
                    language.name }}</b-dropdown-item>
            </b-dropdown>
            <a class="navbar-brand" href="#"><img class="brand-img bsnav-brand-center responsive" data-aos="fade-down"
                    data-aos-duration="1500" src="/static/images/logoDark.svg" alt=""></a>
            <button :class="(!mobile_open) ? 'navbar-toggler toggler-spring' : 'navbar-toggler toggler-spring active'"
                @click="mobile_open = !mobile_open"><span class="navbar-toggler-icon"></span></button>

            <div class="collapse navbar-collapse justify-content-md-between">
                <ul class="navbar-nav navbar-mobile nav-desk">
                    <li class="nav-item">
                        <router-link to="/about-part" class="nav-link effect-underline js-anchor-link" data-aos="fade-down"
                            data-aos-duration="3000">
                            {{ $t('message.about_management') }}
                        </router-link>
                        <!--      <a class="nav-link effect-underline js-anchor-link" href="/about-part"
                                            data-aos="fade-down" data-aos-duration="3000">{{$t('message.about_management')}}</a>-->
                    </li>
                    <li class="nav-item">
                        <a class="nav-link effect-underline js-anchor-link" href="#objectspart" data-aos="fade-down"
                            data-aos-duration="2000">{{ $t('message.ppp_objects') }}</a>
                    </li>
                    <li class="nav-item"> <router-link to="/realized-objects"
                            class="nav-link effect-underline js-anchor-link" data-aos="fade-down" data-aos-duration="2500">
                            {{ $t('message.realized_objects') }}
                        </router-link></li>
                </ul>
                <ul class="navbar-nav navbar-mobile nav-desk">
                    <li class="nav-item"><router-link to="/private-schools" class="nav-link effect-underline js-anchor-link"
                            data-aos="fade-down" data-aos-duration="2000">
                            {{ $t('message.private_schools') }}
                        </router-link>
                    </li>
                    <li class="nav-item"><a class="nav-link effect-underline js-anchor-link" href="#faqpart"
                            data-aos="fade-down" data-aos-duration="2000">{{ $t('message.faq') }}</a>
                    </li>
                    <li class="nav-item"><router-link to="/contact-us" class="nav-link effect-underline js-anchor-link"
                            data-aos="fade-down" data-aos-duration="2000">
                            {{ $t('message.contact_us') }}
                        </router-link></li>
                    <b-nav-item-dropdown right>
                        <template slot="button-content">
                            <div class="lang_icon"></div>
                            <!--                            <img src="/static/images/icons/language.svg" class="d-inline-block align-top" width="26" style="margin-top: -1px" alt="Kitten">-->
                            <b class="lang_suffix">{{ selectedLocale.suffix.toUpperCase() }}</b>
                        </template>
                        <b-dropdown-item v-for="language in languages" :key="language.name"
                            @click="changeLanguage(language)">{{ language.name }}</b-dropdown-item>
                    </b-nav-item-dropdown>
                </ul>
            </div>
        </div>
        <div :class="(!mobile_open) ? 'bsnav-mobile' : 'bsnav-mobile in'">
            <div class="bsnav-mobile-overlay"></div>
            <div class="navbar">
                <ul class="hovertextnavbar-nav navbar-mobile nav-mob">
                    <li class="nav-item"><router-link to="/about-part" class="nav-link">
                            {{ $t('message.about_management') }}</router-link></li>
                    <li class="nav-item"><a class="nav-link" href="#objectspart">{{ $t('message.ppp_objects') }}</a></li>
                    <li class="nav-item"><router-link to="/realized-objects" class="nav-link">
                            {{ $t('message.realized_objects') }}</router-link></li>
                    <li class="nav-item"><router-link to="/private-schools" class="nav-link">
                            {{ $t('message.private_schools') }}</router-link></li>
                    <li class="nav-item"><a class="nav-link" href="#faqpart">{{ $t('message.faq') }}</a></li>
                    <li class="nav-item"><router-link to="/contact-us" class="nav-link">
                            {{ $t('message.contact_us') }}</router-link></li>
                </ul>
            </div>
        </div>

        <div class="jumbotron jumbotron-fluid header" id="headersect" data-aos="zoom-in" data-aos-duration="1000">
            <div class="container">
                <h1 data-aos="fade-right" data-aos-duration="3000">{{ $t('message.ministry') }}</h1>
                <h5 data-aos="fade-left" data-aos-duration="3000">{{ $t('message.department') }}</h5>
                <section id="section03" class="demo">
                    <a href="#aboutpart" id="downbtn"><span></span></a>
                </section>
            </div>
        </div>

        <div class="container section-div" id="aboutpart">
            <b-tabs content-class="mt-3" fill>
                <b-tab :title="$t('message.active')" active>
                    <div class="col-lg-6 col-md-6  offset-md-6">
                        <div class=" form-row">
                            <div class="col">
                                <b-form-select v-model="selected_active_city" @change="fetchActiveSchools">
                                    <option :value="null">{{ $t('message.select_region') }}</option>
                                    <option v-for="item in city" :key="item.id" :value="item.id">
                                        {{ item['city_' + selectedLocale.suffix.toLowerCase()] }}</option>
                                </b-form-select>
                            </div>
                            <div class="col">
                                <b-form-select v-model="selected_active_region" @change="fetchActiveSchools">
                                    <option :value="null">{{ $t('message.select_district') }}</option>
                                    <option v-for="item in sorted_region_active" :key="item.id" :value="item.id">
                                        {{ item['region_' + selectedLocale.suffix.toLowerCase()] }}</option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>

                    <div v-if="school_active.length === 0" class="text-center">
                        <img src="/static/images/nodatafound.png" width="100%" />
                        <h2 class="">{{ $t('message.notfound') }}</h2>
                    </div>
                    <carousel v-if="school_active.length > 0" :data="school_active" :date="true"></carousel>
                </b-tab>
                <b-tab :title="$t('message.offered')">
                    <div class="col-lg-6 col-md-6 offset-md-6">
                        <div class=" form-row">
                            <div class="col">
                                <b-form-select v-model="selected_proposed_city" @change="fetchProposedSchools">
                                    <option :value="null">{{ $t('message.select_region') }}</option>
                                    <option v-for="item in city" :key="item.id" :value="item.id">
                                        {{ item['city_' + selectedLocale.suffix.toLowerCase()] }}</option>
                                </b-form-select>
                            </div>
                            <div class="col">
                                <b-form-select v-model="selected_proposed_region" @change="fetchProposedSchools">
                                    <option :value="null">{{ $t('message.select_district') }}</option>
                                    <option v-for="item in sorted_region_proposed" :key="item.id" :value="item.id">
                                        {{ item['region_' + selectedLocale.suffix.toLowerCase()] }}</option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>
                    <div v-if="school_proposed.length === 0" class="text-center">
                        <img src="/static/images/nodatafound.png" width="100%" />
                        <h2 class="">{{ $t('message.notfound') }}</h2>
                    </div>
                    <carousel v-if="school_proposed.length > 0" :data="school_proposed"></carousel>
                </b-tab>
            </b-tabs>
        </div>
        <div class="container text-center section-div" id="objectspart">
            <h1 class="section-head" data-aos="zoom-in" data-aos-duration="1500">{{ $t('message.ppp_objects') }}</h1>
            <h4 data-aos="fade-up" data-aos-duration="1500">{{ $t('message.select_region') }}:</h4>
            <div class="mapdiv container">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 792.49 516.88">
                    <g id="Слой_2" data-name="Слой 2">
                        <g id="Слой_1-2" data-name="Слой 1">
                            <path id="TJ-SU" class="cls-1"
                                d="M676.69,291.56l-1.51-1.77-1.2-.52.27-.37-.73.55-.27.48.19.67,1,0,1.22.9,3.18,4.31.2-.35-.64-1.58-.77-1Z" />
                            <path id="TJ-SU" class="cls-1"
                                d="M677.2,291.88l-1.5-1.8-1.2-.5.3-.4-.7.5-.3.5.2.7h1l1.2.9,3.2,4.3.2-.4-.6-1.6-.8-1Z" />
                            <router-link to="/city/4">
                                <path id="UZ-AN" title="Андижан" class="cls-1"
                                    d="M750.8,320.68l-.1-3.6-.3-.8-4-1.3-2.3-.5-.2.2h-.3l-9.3-1.6-2.2-3.5-.6-.7-3-1.6-4.2-.6-.2,1.4-3-4.5h0l1.9-1.2-2.2-2.7,2-1.9,1.2-.8,8.6-2.2h3.7l.6.3.7.6,3.3.7,1.5.2,4.9-.4.5-.3.4-.4,1.3-5.9h0l.2.2h.7l2.8-1.4.8-.2,1.2-.9,1.1-1.2.7-.1.2.2,1.3.3,1,.7h.9l.8.4.9-.1.8.2.7.3.3,1.2-.1.6-.8,1.5v.2l.2.2h.2l.5-.7h.4l.5.2.4.4,1.3,2.3.6.7.2,2,.8.6,1.2.3,1.3.7,1.6.6.5-.2,1.8.3.9-.4.9-.2.7.2,2.2-.6h.7l.8.4,1.5,1.7.4,1,.2.1.7.2h.5l.6-.3.2-.3.6-.3.4-.5h.6l.4-.2-.2-.5-.6-.4-.3-.5.4-1.4.2-.2h.4l1,1.5.9.2,1.1.8,1-.5,1.5.1.4.4.2,1-.4,1.7-.4.6-.5.3-2.9,1.2-1.7.2-.6.9-1.2.8-1.4.8-.8.2-.1.2-.9.2-1.3.7-1,1-1.5.5-1.1-.1-.8.1-.3.4v.3l.1.4.4.5v.3l-.7.6-.1.4.2,2.7-.1,1.1-.7.2-.5-.3-1-1-1.5-.3-.3.4v.8l-.9.6-.1.2-.2,1.4-.6,1.1-.7.2h-.4l-1.4-1.1-1.5-.1-.7-.4-.9-.9-.5-.2-.7.3h-.2l-1.4-1.7-.6-1-1.4-1.2-.4-.2-1,.4H757l-.4.5.1.3,1.1.4.3.3.5,1,1,.3.4.6v.6l-.3.4-1,.1-.3.2-.2.5.1.5,1.1-.1.3.4.2,1.5.5.5.2.8-1.1,2.7.3.8-.1.6-.2.2-.3.1-1.5-.4-.4-.3-1.6-1.6-.6-.5-.3-.1-.8.3-.3-.2-.5-.7-.3-.2H752l-.3-.1-.2-.4.3-1.1-.1-.3-.4-.3Z" />
                            </router-link>
                            <b-tooltip target="UZ-AN" custom-class="my-tooltip-class">{{ $t('message.andijan')
                            }}</b-tooltip>

                            <router-link to="/city/12">
                                <path id="UZ-BU" title="Бухара" class="cls-1"
                                    d="M421.7,383.68l-3.8,3.6-3.4,2.2-.6.1-4.4,4.7-.4,1,.1.9.7,1.2.8.9.8,1.2.2.5-.3.6-18.1,6.6-5.6,6.2h0l-2.1-2.3h-.4l-1.2.3-2.1,1.2-1,.3h-1l-1.4-.2-.9-.4-3-2.4-2.9-2-6.8-5.2-1.8-1.2-4.7-3.4-1.3-1.3-1.1-1.4-.3-.6-.4-.4-.8-1.2-3.6-3.5-2-2.1-4-2.8-4.4-2.6L336,379l-4.2-2.8-10.3-7.3-7-4.8-13.8-10.5-1.2-1.1-.9-1.3-.2-.5-.2-.9.1-.6-.3-.7-.1-1.8-1.4-2.1V344l.7-1.2.1-2.6-.4-1-.1-1.2-.6-2-.1-1.1-.2-.8v-.6l.4-.9v-1l-.8-1.3-1.2-1.1-.7-1.1-.1-.5.5-1.5.3-1.5v-.3l-1.3-.5-1.3-.8-1.3-1.4-1.3-.6-1.3-.9-.4-.6h0l6.3-7.6,4.6-5.1.8-3.8v-1.5l-.7-1.1-5.9-6.7-3.2-3.3h0l10.9-5.1-13.8-19.2h0l.6-.3,3.7-.9,13.5-3.2,1-.1,3.3,6.7,1.4,2.1,2.1,2.3,2.4,1.6,3.5,1.9,1.6,1.6,2.1,4.4,1.4,5.1.6,1.4.9-.1.5-.4h2l3.2.9,5.4,2.3,8.5,4.6,9.8,5.7,2.1,1.7.6,1,.3,1.5-.5,2.2,3.4-.1,2.6-.2.5-.2,5.4-12.2,1-1.1,2.2-1.2.9.1,1.7,1.9.1,7.6,16.2,1.9.2-.5.8-4.5.6-.2,5-.6,3.8-.1,2.3-.4,1.1-2.7.7-2.1.4-.2,1,.2.8,2.8,2.1,10.1,1.1,1.1.8.4,1,.3,8.6,1.2,5.9.6,8,1.1-1.4,9.3-4,2.8-.2,1-1.4,4.1-3.4,4.1-.6.6-.9.4-3.9-.2-2.9-.5-2-1-.8-.8-2-1.3-2.1-.1-1.1.5-.4.6.4,3.3-.5,4.4-1.3,5.7-2.5,4.8-2.1,2.5-4.4,2.7-.9.3-1.4,2.7,4.3,5.8,1.2,1.2,7.1,2.7,1.1.1,3.2-.8,4.9,3.7,4.4,9.4.4,1.1Z" />
                            </router-link>
                            <b-tooltip target="UZ-BU" custom-class="my-tooltip-class">{{ $t('message.bukhara')
                            }}</b-tooltip>
                            <router-link to="/city/3">
                                <path id="UZ-FA" title="Фергана" class="cls-1"
                                    d="M674.2,331.68l.1-.7-.2-.5-.7-.7-2.9-1.3-1.6-.3-1-.4h-.3l-.9.4h-.4l-.5-.2-.3-.4-.5-1.1-.3-.3-.3-.1-.1-.7-.9-1.8-.1-.6.1-.2.8-.2,1-.8,1.2-.2,1.1-.6,2-.7h.8l.5-.4.1-.8.4-.4.1-.9.2-.4.4-.2.6-.1.8.1.5-.4h.7l.4-.2.9-1.1,1.1-2.2.4-.4.6-.2.7-.7.5-.2.2-.3.4-.1.4-.5,1-.2.4.3h.3v-.7l-.2-1,.3-.2.3.3h.7l.4-.6.3-1,.6-.5.1-.3h0l.3-.1.3-.3,4.9-1.3,3.4-.6,6.8-.1v.2l-.4.5-1.4,1.7.8,2,1.9,1.9,5.6,2.7.4.1.8-.4,3-2.8.8-1,.7-1.4,1.2-.8,4.1-2.2,3.4-1h0l3,4.5.2-1.4,4.2.6,3,1.6.6.7,2.2,3.5,9.3,1.6h.3l.2-.2,2.3.5,4,1.3.3.8.1,3.6h-.5l-1.1-.3-.4.1-.5,1.4-.3.5-.6.6-.5.2-.4.1-.6-.2-.9-.6-.5,1,.5,1.7-.1.3-.6.7-.1.6-.3.4-1.4.4-1,1.3-.5.4-.8,1.1-1.2.5-.9.9-.1.3.2.5,1,.2,1,.9-.1.5-1.1,1-.5,1.1-.3.3-.7.3h-.6l-1.1-1.2-2-.5-.5.4-.1.5.1.3.7,1.1v.5l-.8.5h-.5l-2.5,1.6-1.3.4-.9.7-.4.1-.3-.1-.5-.9-.4-.5-.2-.1-.4-.4-.1-.4.2-1.9-.2-.8-.7-.9-.5-.4-.8-.1-1.2.1-.1.8.2,1.4-.2.9.1.6-.1.2H722l-.8-1h-1l-.6.2-.9-.6-1.8-.8-.2-.5.2-1.4-.2-.5h-1.3l-1.5-.4-.6-.5-1.1-1.2-.4-.3-.5-.1-.5.2-.6.1-.2-.3.1-.4-.3-.3-1.5.6-.8.1-.3-.1-.1-.3v-1l-1.5.1-1-.3-1-.1-.8.1-1.4.5h-1l-.6.2-2.6,1.8-1.9.3-2.1.9-.5.3-.1.3.3.9-.1,1-2.4.1-2,.4-.3-.1-1.7,1.3-2.5,1.1-1.6.3-1.4.1-3.1.7-.8-.3-1.2-2.1-.3-.9-.7-.4-.5-.9.1-.1.1-1.3.4-1-.5-1.8Z" />
                            </router-link>
                            <b-tooltip target="UZ-FA" custom-class="my-tooltip-class">{{ $t('message.ferghana')
                            }}</b-tooltip>
                            <router-link to="/city/7">
                                <path id="UZ-JI" title="Джизак" class="cls-1"
                                    d="M581.1,375l-.5.3-.2,1.5-.3,1-.8.7-1.1-.4-1.1.3-3-.5-1.9.8-.4-.1-.8-.8-.5-.2-1.4-.3-1.8-.2-1.3.1-.9.3-.7-.1-1-.6-.7.1-2.2-.2-1-.5-.7-.2-1.1.1-.6-.1-1.1-.9-.9-.4-1.4-.1-.9.1-1.9-.8-1-.9-1.4-.1-2.4-1.6-.7.4-1.2.3-1.9-.8h-.4l-.9,1-1.1.4-.6.5-.9,1.5-.6.2h-1.4l-4,1.5-.1.7.2,1.6-.4.5-2.2-.6-.5.1-.4.8v1.3l.3.5h0l-4.5-3.8-1-1-.6-1-.2-.9v-4.2l.1-.4,3.2-5.2.8-.9.7-.5,2.2-1,1.5-.4,1.3-.1-.1-1-1.1-6-.2-.2-11.9-2.5-4.8-.4-2.1-.8-5.8-3.9-.4-3.7.1-.4,1.2-.3.2-.2.5-1.3.1-.8-1.4-2.8-1.9-1.7-.8-4.1-.1-3.9.1-.8.8-1.8v-1.1l-1-2.2-4.6-.1-7.8-.9h0l.7-1.8,4.4-8.6,3.1-5.3.3-.7-1.6-6.9-.2-.5-.3-.2-4.3-1.1-1-.6-.7-1.3-1.1-10.6,6.7-.2.3-2.9h.2l.5-4.8h0l17.4,1.3,4.6.5h2.7l.9.6.9.1,1.3-.4,1.3-.2,15.4.5,1.4,1.3.9.2,2,2.5,3.3,3.1,1.5-1.3.8,1.2,3.1-2,1.4,1.3.6-.3.8.5-2.5.5-1.4,1.5,1.4,3.5-1.5,1.5.1,5.2-4.1.1-.7,2.3,1.4,2,2.4.7L560,305l3.6,4,3.8,1.3.4.4h0l-.2,2.8-.3.6-1.9-.1-2.1.5-.5,4.9.2.3,2.1-1,.3-.1.2.2-.2.8-.8,2-5,11-.2,1.5.2,1,.3.9.7,1h.3l6.5.3,4.6-.2,4-.8,2.3-.8,7.1-1.6.3.7-1,6.4h0l-1.5.3-.1.1-2.9.8-.2.6.9.8,2.6,1.5h1.2l2.2-.5,1.3-.6,2.9-.8,1.2-.6,3.4-.9,1.7-.2,3.2-.1.8.6.4,1.3.5,2.4-.3.7-.8.1-1.5-.3H598l-1.5.4-1.2.9-.2,1-.2.1-.5-.3-.3-1.3-.7-1.1-.6-.1-.6.2-.2.3v.5l.4.6.9.9v.6l-.4,1.4v.3l1.5,1.4,2.6,3.2.5,1.1v.8l-.2.7-.7.7-.8.1-.6-.3-.6-.9-.1-1.8-1.3-3.2-.7-.9-.4-.1-.5.2-.1.4.1,1.1,1,2,.8,1.9v.7l-.4.8-.4.3-.9.2-.3.4-.3,1.4-.2.2-.2.2-.6-.4-.3-1.3-.8-.9-.5-.1-1.5,1.2-.5-.3-1.2-.1-.1,1.1.3,1.7-.3,1.3-.5.9-.3.9-.3.6-.6.3h-.6l-.4.5.3.6,1.9,2.7-.3,1.7-2.4,2.7Z" />
                            </router-link>
                            <b-tooltip target="UZ-JI" custom-class="my-tooltip-class">{{ $t('message.Jizzakh')
                            }}</b-tooltip>
                            <router-link to="/city/5">
                                <path id="UZ-NG" title="Наманган" class="cls-1"
                                    d="M749.8,281.48l-.5-.8-.5-.3-.5-.1-.5.2-1-.4H746l-1.9,1.4-.3.1-.7-.3-1.7-1.1-1.1-.3-1.2-.1-1.2.8-.5-.2h-.6l-1.6-.6-.3-.4v-.9l-.6-.1-.4-.2-.1-.2.6-2,.9-1.6.8-.8.5-.8.6-1.4v-.3l-1.1-.6-.8-1-.3-.6.1-1.3-.1-.4-.4-.3-.4.2-.3.6-.8.2-.3-.2-.1-.2.3-1.3-.6-1.1-1.4-1.4-1-2.2-.4-.1-.1.1-.1,1.7-.2.3-.3.1-.2-.4-.1-.7-.3-.3h-.4l-.6.5-.1.4.4.7-.1.6-.3.2-.4-.3-.4-.7-.1-.5.1-.4.8-1.1.5-.8.1-.5-.2-1.4.1-.3-.1-.7.4-.9-.3-.8h-1.1l-.4.1-.8.7-.8,1.4-.4.5-1.3.4-.2.4v.4l.3.2,1.1.1.6.2.5.8.1.7-.3,1.2-.4.8v.4l.8,1.2-.3.7-.7.7-.4.7-.3,1h-.2l-.4-.3-.3.3-.3.7-.6.5-.2.6h-.2l-.3,1-.4.3-.6-.2-.6-.7-.4-.2h-.9l-.4.4-.7.1-.8-.5-.3.1-1.4,1.7v.4l.3.8-.3.9v.5l.2.4.9.4.3.7-.9,2-.3,2-.7,1.6v.4l-1,1.1h-.5l-.3-.2-.2-.3-.2-1.8-.2-.5-.8-.8-.4-.2h-.5l-.5.3-.3.4-.2,1.4-.4.8-.8.8-.5.1-.4-.1-.1-.3.2-2.4-.3-1.4-.3-.4-1-.6h-.3l-.6.3-.1.4v.5l-.3.2-.3-.1-.4-1.1h-.3l-.3.3-.5.7h-.5l-.3.1-.8.9-.5.3h-.4l-1.2-.4-.4-.4-.6-1-.8-.2-1.2-.8h-.6l-2.7,1.8-.6-.2-.5-1.2-.9-.9-.9-.5-.6-.9-.5-.5h-.3l-.7.3-.5.7-.8,2.1-.3.4-.3.2-.8-.4-.5-.6-.2-.9v-1.1l.7-1,.2-.6-.1-.4-.6-.9-.3-.7-.1-1.8.4-.9.3-1.2-.5-2-2.5-4.1-.4-1.2-.2-.2-1.2-.3h-.3l-1.1.9-1.2-.1-1.5.5-1,.8-.4.7-1.7,1.4h-2.1l-.5-.5h0l-.7,1.9-3,4.1.7,7.3,1.9,2.6.7,1.3.2,2.3v1.8l-.2.9.2.4h.5l.7.4.3.7,1.1.9.1.6.3.2.9,1.2h.7l.5,1.4,1,1.3.4.9,1.1,1.6.5,1.2h.3l.1.4,1,.8.6,1.4.8.3.5.5.7,1-.5.4-.2-.1-.3.2.1.3-.2.3-.4.1-.6-.3-.5-1.2-.4,1.2v.7l.3.6.8-.2,1.2.1.8.5-.3.2h.9l.4.2,1,.9.2.5h0l.3-.1.3-.3,4.9-1.3,3.4-.6,6.8-.1v.2l-.4.5-1.4,1.7.8,2,1.9,1.9,5.6,2.7.4.1.8-.4,3-2.9.8-1,.8-1.5,1.2-.8,4.1-2.2,3.4-1h0l1.9-1.2-2.2-2.7,2-1.9,1.2-.8,8.6-2.2H736l.6.3.7.6,3.3.8,1.5.1,4.9-.4.5-.3.4-.5,1.3-5.9h0l-.4-.3-.5-.6.2-.3,1.3-.3.5-.4.5-1-.5-.8Zm-70.5,14.7-3.2-4.3-1.2-.9h-1l-.2-.7.3-.5.7-.6-.3.4,1.2.5,1.5,1.8,1.7,2.4.6,1.6Z" />
                            </router-link>
                            <b-tooltip target="UZ-NG" custom-class="my-tooltip-class">{{ $t('message.Namangan')
                            }}</b-tooltip>
                            <router-link to="/city/11">
                                <path id="UZ-NW" title="Навои" class="cls-1"
                                    d="M498.9,275.28l-.5,4.8h-.2l-.3,2.9-6.7.2,1.1,10.6.7,1.3,1,.6,4.3,1.1.3.2.2.5,1.6,6.9-.3.7-3.1,5.3-4.4,8.6-.7,1.8h0l-1.3-3.5-1.9-2.7-1-1.1-.6-.3-2.1,1.9-2.4,1.3-1.4.1-1.8-.3-1-.8-1-1.5-1.2-.1-1.1.2-.9,1.1-2.1,4.7-.6,4.9.3.4.5.2.4.7-.2,2.3-.9,6.1-.9,1.3-2.3,6.1.2,1,.8.1,1.4-.9.8.1.2.4-.1,1.1-.4.6-3.5,3.3-1.6.8-8.9,1.9-1.2-.2-5.4-2.3-2.1-1.1-.5-1-1-1.5-5.5-2.1-1-.2-.5.3-.4.6-.2.7.1,1-.4,5.8-1.8,5.5-.7,1.3-.5.3h-.6l-2.9-.9-1-.5-8.6,2.9-.5.4-.1.4.3.8,1.5,1.5,1,.8.9,1.4,1.4,5.2-.2,1-.5,1.5-1.2,2.3v.6l.2.8.8,1.8,2.1,3.8h0l-.4.4-.5.2-2.6.4-1.4.4-.8.4-1.2.8h0l-.3-3.4-.4-1.1-4.4-9.4-4.9-3.7-3.2.8-1.1-.1-7.1-2.7-1.2-1.2-4.3-5.8,1.4-2.7.9-.3,4.4-2.7,2.1-2.5,2.5-4.8,1.3-5.7.5-4.4-.4-3.3.4-.6,1.1-.5,2.1.1,2,1.3.8.8,2,1,2.9.5,3.9.2.9-.4.6-.6,3.4-4.1,1.4-4.1.2-1,4-2.8,1.4-9.3-8-1.1-5.9-.6-8.6-1.2-1-.3-.8-.4-1.1-1.1-2.1-10.1-.8-2.8-1-.2-.4.2-.7,2.1-1.1,2.7-2.3.4-3.8.1-5,.6-.6.2-.8,4.5-.2.5-16.2-1.9-.1-7.6-1.7-1.9-.9-.1-2.2,1.2-1,1.1-5.4,12.2-.5.2-2.6.2-3.4.1.5-2.2-.3-1.5-.6-1-2.1-1.7-9.8-5.7-8.5-4.6-5.4-2.3-3.2-.9h-2l-.5.4-.9.1-.6-1.4-1.4-5.1-2.1-4.4-1.6-1.6-3.5-1.9-2.4-1.6-2.1-2.3-1.4-2.1-3.3-6.7-1,.1L290.9,265l-3.7.9-.6.3h0l-20.9-28.7,12.9-7.1-6.7-12.1,1.3-15.8,27.7-52.2-15.4-4.2-5.8-10.5h0l42.4-8.2,20.5-3.6,3.5.7,3,.4,9.7,1.1,5.9.4,2.4.4,14.2,1.1,13.6.7.2-.1h.9l10.5-5.2,7-3.1,4.4-2.2,2.1-.5,1.1-.1,1.7.1.8.3.8.6,1,1.1,5.7,12.6,2,1.9,3.6,3.7,10.9,9.7,1.5,6.1,6.6,21.4,12.6-5.9.4,31.3-.1,7.2-.6-.2-2.4-1.2h-.9l-.1,6.6-.9,1.1-.3,16.6.1,2.1,24.1,2.9,3.5,39.7Z" />
                            </router-link>
                            <b-tooltip target="UZ-NW" custom-class="my-tooltip-class">{{ $t('message.Navai') }}</b-tooltip>
                            <router-link to="/city/9">
                                <path id="UZ-QA" title="Кашкадарья" class="cls-1"
                                    d="M421.7,383.68l1.2-.8.8-.4,1.4-.4,2.6-.4.5-.2.4-.4h0l.7.2,17.6.5,1.5-.2,1.3-.6,1.4-1.1.2-.3v-.3l4.3.9,3.3,3.8,2.8,4.6.1,1.5.2.2.7.3,3.1.8h1.5l2.2-1.4,3.3-1.7,7.6-1.9.6.2,1.2.8,1.6,1.4,1.6,1.1.7.3h.3l3.6-1.6.8-1,1.1-1.8.8-.9.8-.3,1.2-.1,8.6,1.5.6.7.5,1.3-.1,1.3-.5,1.7.1.6.3.5.9.5,1.9.2,3.9-.2.8-.2.4-.5.1-.3-.1-1.8.4-.5h.9l4.5,1.3,2.6,1.1,3.8,1.2,1.7.3,1-.2h0l.4,1.6,1.4,2.4.7.8,1,.5,1.8.4.6.4.9.3h.8l1-.2,1.1.2,1,.5.6,1.7.6.2,1.6.1.3.3v.6l-.4.5-.2,2.5.4,1.3.1,2,.4.6h0l-.8.8-1,.6-4,.2-.9.3-.5.3-.7.6-.5.8-.1.4.5,3.1,1,2.1.4.5.2.5.1,4.2-1.3,4.3-.5-.2-1.4-1.4-1-.3-1.4-.1-1.1.3-.5.3-.6.6-.8,1.3-1.2,2.2-8.9,8.9-.7,3.4-.2,1.5-.4,1.4-.4.9-2.4,2.4-1.8,1.3-3.5,1.9-11.6,12.1-.4,1.3-1,4.3.3.9h0l-2.4-2.8-1-.7-1.5-.6-3.2-.3-2.6.8-.6.1-1.3-.3-1.2-1.1-2.8-1.6-1.8-2.1-1.3-2.3-.5-.3-1.9-.1-3.5-1-.6-.4-.5-1-1.2-.4-.9-.1-.8-.8-.5-.2-1.4.1-.8-.3-.9-.6-1.9-2-.9-.2h-1.1l-1,.3-.7,1.4-.6-.1-.1.1-.2.6-.4.2h-.2l-4.7-1-9.9-3.9-1.9-1.1-6.5-4.5-1.9-1.5-2.7-2.5-7.6-7.6-.6-.4-2.7-1.3-3.5-1.3-2.9-1.4-1.7-1.3-.6-.7-9-5.6-2.7-1.9-5.5-5.1-1.2-1.3h0l5.6-6.2,18.1-6.6.3-.6-.2-.5-.8-1.2-.8-.9-.7-1.2-.1-.9.4-1,4.4-4.7.6-.1,3.4-2.2Z" />
                            </router-link>
                            <b-tooltip target="UZ-QA" custom-class="my-tooltip-class">{{ $t('message.Kashkadarya')
                            }}</b-tooltip>
                            <router-link to="/city/14">
                                <path id="UZ-QR" title="Каракалпакстан" class="cls-1"
                                    d="M157.9,24.08l.4,7.7-2,5.8L153.1,43l-2.8,6-1,4.2h-2.2l-1.8.2-1.4,1.4-.6,2.6.8,4.6,1.2,2.6.8,2.8-2.4.8-3-1.6L138.3,68l-1.8,4-2.4,4.2-2.2,2.4-3-1.8-.4-4-.2-6.2L127.1,65v-3.5h1.6l1.2,2.8,1.8,1,2.8-1,1.4-3v-4l1-3.2-3-1.8-3.2-2.6-.6-2.4,1.8-2,1.8-.4,2,1,.2-8.3,2.8-.4-.2-3.2-2.4-.6-3.8-.6-1.4,1-1.6,2-2.2,1,1.4-2.2,2.8-5.2,1.8-2.6-1-3-2-2.8.6-3.8,1-3.4,3.4-6.4h0ZM119.6.68l-.2,3.5-1.6,3.2-.2,4.8-3.8,3.4-2,3.2-.2,5.8-2.6,2.6-1.2,5.6-3,4.8-2,5.4-.4,4.6.2,6,1.2,2.8,2,3.6-.4,2.6-3,8.5.4,5.2,2.2,5.2,2.2,2.6,3,1.4,4,1.6,3,.2,2.6,2,2,.6,1-2,1.6-.4,2.4.2,1.8-.8,5-1.6,2.6-1.2,1.6,1,.9,4.1-1.8,2.2-2.8,1.8,1,3.6,2.2,1,1.8,1.8,5.2.8,2.6,2.2,3,.4,6,.6,4.4.2,3.6-2.2,2.4,1.4,1.2,1,3.8-.8,2-.6,3.6,1.2,5-1,4.8-1.6,7.1-2.8.6-2.6h3.4L199,94l-1-1.8,1.6-3.4,6.2-5,4.6-4.6,2.8-5,.8-3.8L213,69l-1.6-1.4-1-2,3.9-.3h0L236,81l2.2,7.1,6.1,6.1,6.4,7.7.3.6.6.6,2.5,3,5.7,7L276.6,134l1.6,1.6.5.1h0l5.9,10.5,15.4,4.2-27.7,52.2-1.3,15.8,6.7,12.1-12.9,7.1,20.9,28.7h0l13.8,19.2-10.9,5.1h0l-2.5,1.2-.6-.2-.3-.2-4.6-7.4-1.5-2.8-8-8.8-3.1-1.9-3.5-1.9-8.9-2.1h-3l-.6.2-1.4.8-.8.9-1.2,2.3-.5,1.9-.7.8h-1.5l-2.3-1.4-.3-1.2-.4-.9-2-2.3-.7-.6-.7-.3-2.2-.4-1.4-.6-6-4.5-8.2-7.3-1.6-1.5-3.4-3.9-5.2-4.8-.7-.3-.7-.6-.4-.5-3.1-5.4-.4-2.5v-2.6l-.2-.6-.4-.5-5.3-1.1L196,231l-1.9.8-2.7,5.2h0l-.2-.5-.5-.6-.6-.4-2.4-.8-.8-.5-1.8-2.2h-.2l-.3-.4-.9.2-1.3-1.2-.2-.8.2-.3.6-.4,2.8-.2.4-.4-.2-.8-.5-.7-.4-1-.2-.9-.2-2.3-1.3-1.6v-.7l.2-.5,1.1-.6.4.2.9.1.5-.1.4-.4.3-.4v-.6l-.5-1.2-.5-.6-1-.6-1.8-.2-.6-.2-.8-.7-.8-1.1-.7-1.4-.6-.6-2-.6-1-.8-.3.6-.5,1.4-.4.4h-.5l-1.8-.6-.7-.4h-.5l-.5-.2h-2l-1.6.4h-1.5l-1.3.2-7.4.1-.6-.4-.7-1.4-.6-.3-.9-1.1-4-4v-.4l.5-1.2-.1-1.2-3.4-4.4-.5-.5-1.1-.7-.4-.1-1.1.3-1,.8-.6.2-2.6-.2-.7-.2-1.6-.9-2.3-.7-.7-.3-1.7-1.5-4.2-4.6-4.8-5.4-3.1-3.9-.5-.4v.9l-.3,1.2.1.6.9.9v.3l-.2.5-.3.2H121l-.6-.3h-.6l-.5.6v.2l.7.6.3.4-.4,2.2-.3.5-.5.3-1.2-.4-2.7.5-1.1.1-1.3-.6-1.2-.2-1.2-.6-1.5-.4-2.9-.6h-.9l-1.4.6-1,.6-2.3,1.9-.6.1-.4.4-.2.7.3.8,1.9,1.4,2.4,1.3,1,.4,1.3.3.4.5,2.7,6.2,1.3,2.1.6.7.2.9v1.2l.4.4.5-.1,3.2,2,1,.8.1.7-.5,1-.4.3h-.4l-2.1-.5-1.9.4-.2-.7.1-2-.1-1.1-.8-2.9-.7-1.3-.9-1-1.3-.8-4.8-1.3-.8.1-2.2,1.1-1.3.5-.2-.1-.2-.7-.9-.6-.3-.4-.3-1.2-.8-.8-1-.2-1.4.3-1,.7h-.5l-.3.3-.4,1.8-.3.8-.3-.1-.7-.9-.4-.1-.7.2-.2.4-.3,1.6.3.8.9.8.4.7.3,1.1v.5l-.4,1.1v1.4l-.2,1.1.1,1.6-.2,1.6-.2.6-.3.4-.5.2h-.8l-.7-1.9-.4.1-.3.5-.3,1.2.7,1.2.4,1.1-.2.4-.9.1-3.1-.5-2.6.9-1.8.9-.7.2h-.6l-1.6-1-1.9-.4-2.3-.2-5.2.3-2,.7-2.5,1.2-2.2,1.6-1.3,1.1-1.1,1.6-.4.9-.7,1.6L54.6,230l-.6.9L52.9,232l-.7.4-1.4.5-2.2.6-.7.4-.9.8-.9,1.9-.3,2-.5,1.8v2.8l.3,2.7-.1,2.7.6,2.4.4,1,.4.5v.2l.4.2.5,1,.2,1.2.1.8-.2,1.2v2.3l.4,3.1.3,1,.4.7,1.8,2.6h.9l2-.6.4.4v.5l-.3.7-.4.4-.5.3-2,.7-.8.8-.5.9v1.5l-.3.7-.5.5-.5.3H47l-1.8-.4-4-.3-4.2-.6-6.8-.4-3.8-.1-5.9-.7-3.5-.3H15.1l-5.2-.5-9.4-.4L.7,38.08l1.5-.4,1.5-.6,30.1-9.9v-.1l1.7-.3.3-.4,1-.3,13.1-4.2L93.6,8.38l6.7-2.2,2.2-.5Z" />
                            </router-link>
                            <b-tooltip target="UZ-QR" custom-class="my-tooltip-class">{{ $t('message.Karakalpakstan')
                            }}</b-tooltip>
                            <router-link to="/city/8">
                                <path id="UZ-SA" title="Самарканд" class="cls-1"
                                    d="M533.4,391.18l-.1.3-1.6-.3-1,.2-3.3,1.1-.2.3v.2h0l-1,.2-1.7-.3-3.8-1.2-2.6-1.1-4.5-1.3h-.9l-.4.5.1,1.8-.1.3-.4.5-.8.2-3.9.2-1.9-.2-.9-.5-.3-.5-.1-.6.5-1.7.1-1.3-.5-1.3-.6-.7-8.6-1.5-1.2.1-.8.3-.8.9-1.1,1.8-.8,1-3.6,1.6h-.3l-.7-.3-1.6-1.1-1.6-1.4-1.2-.8-.6-.2-7.6,1.9-3.3,1.7-2.2,1.4H466l-3.1-.8-.7-.3-.2-.2-.1-1.5-2.8-4.6-3.3-3.8-4.3-.9v.3l-.2.3-1.4,1.1-1.3.6-1.5.2-17.6-.5-.7-.2h0l-2.1-3.8-.8-1.8-.2-.8v-.6l1.2-2.3.5-1.5.2-1-1.4-5.2-.9-1.4-1-.8-1.5-1.5-.3-.8.1-.4.5-.4,8.6-2.9,1,.5,2.9.9h.6l.5-.3.7-1.3,1.8-5.5.4-5.8-.1-1,.2-.7.4-.6.5-.3,1,.2,5.5,2.1,1,1.5.5,1,2.1,1.1,5.4,2.3,1.2.2,8.9-1.9,1.6-.8,3.5-3.3.4-.6.1-1.1-.2-.4-.8-.1-1.4.9-.8-.1-.2-1,2.3-6.1.9-1.3.9-6.1.2-2.3-.4-.7-.5-.2-.3-.4.6-4.9,2.1-4.7.9-1.1,1.1-.2,1.2.1,1,1.5,1,.8,1.8.3,1.4-.1,2.4-1.3,2.1-1.9.6.3,1,1.1,1.9,2.7,1.3,3.5h0l7.8.9,4.6.1,1,2.2v1.1l-.8,1.8-.1.8.1,3.9.8,4.1,1.9,1.7,1.4,2.8-.1.8-.5,1.3-.2.2-1.2.3-.1.4.4,3.7,5.8,3.9,2.1.8,4.8.4,11.9,2.5.2.2,1.1,6,.1,1-1.3.1-1.5.4-2.2,1-.7.5-.8.9-3.2,5.2-.1.4v4.2l.2.9.6,1,1,1,4.5,3.8h0l2.2,4.7.8,2.3.9,1.9.2.8Z" />
                            </router-link>
                            <b-tooltip target="UZ-SA" custom-class="my-tooltip-class">{{ $t('message.Samarqand')
                            }}</b-tooltip>
                            <router-link to="/city/6">
                                <path id="UZ-SI" title="Сырдарья" class="cls-1"
                                    d="M596.6,338.08l-1.6,1-1.3.3-2.4-.7-1,.4-5.4,1.7h0l1-6.4-.3-.7-7.1,1.6-2.3.8-4,.8-4.6.2-6.5-.3h-.3l-.7-1-.3-.9-.2-1,.2-1.5,5-11,.8-2,.2-.8-.2-.2-.3.1-2.1,1-.2-.3.5-4.9,2.1-.5,1.9.1.3-.6.2-2.8h0l3.7,3.1,1.9-.5,1.9,1.6-.5,1.1,4.9,1.4.8-1.1,2.4.2,4.3-1.7-.8-2.1-2.4-1.3-1.1-3.3-3.3-4.5.9-7.5-1-2.5.9-.9-.9-1.4-3.6-.2v-1.3l4.9.3.3.6,2.4-1.5v.2l.3.1.2,1.2.7.3.8-.4.9.2.4.4-.1.3-1.4.5-.2.4v.6l.5,1.1.4-.3h0l4.9,5.5,3.5,3.5,4.9,4.4,4.7,3.9.6.1,3,4.2-.5,4.7-.9,5.3-1,5v1.1l.1.6.5,1-.3,4.7h0l-1.1-.4H602l-3.4.4Z" />
                            </router-link>
                            <b-tooltip target="UZ-SI" custom-class="my-tooltip-class">{{ $t('message.Syrdarya')
                            }}</b-tooltip>
                            <router-link to="/city/10">
                                <path id="UZ-SU" title="Сурхандарья" class="cls-1"
                                    d="M573.7,459.78l-1,3.5-.1,1.2-2.3,2.4-1.6,3.1.1,1.6-.5,1.1.1.8-.3.9-2.5,1.2-4.1.7-.8,1.4-3.2,6.8-1.2,1.7-1.4,1-2.3,3-1,2.4-1.3,2.4-1.6,1.5-1.2,3.9-.1,2.6.3,4-.6,6.7-.7,2.4-.7.4-.6-1.1-1.4-1.2-.7-.2-1.4.1-.4-.1-.9-.8-1-.6-.6.1-1.4.5-.7.5-.4.5-.7.1-.4-.7-.4-1.4-.7-.7-.8-.4-.7.1-.6.4-1.9,1.7-1.3.5-1.2.7-1.3.1-1.8.5-1,1-1.5.6-.5-.2-.9-.8-.2-1.5-.3-.5-.8-.4-.4-.9-.3-.3-1-.4-.5-.3-.7.1-.5-.1-1.5-.9-.5-.7.4-1.5-.3-.8-1.7-.9-1.4-1.4-.4-.3-1.9-.7-1.9.1-3.6,1.6-1.6-.2-.8.1-2.2.8-2-.5h-1l-1.1.4-1.6-.4-1.5.2-1.2-.1-1.8.1-1.3.5-.4-2,.2-.7.4-.6.9-.6,1.1-.6,3-.9.3-.7v-.8l-.4-1.1-4.6-5.5.3-1.1.6-5.6-.3-1.5v-.6l.5-3.1.7-1.8.7-1.1.8-.8.5-1.3.6-.7,2.3-1.3.4-.4.2-.8v-.9l-.5-1.1h0l-.3-.9,1-4.3.4-1.3,11.6-12.1,3.5-1.9,1.8-1.3,2.4-2.4.4-.9.4-1.4.2-1.5.7-3.4,8.9-8.9,1.2-2.2.8-1.3.6-.6.5-.3,1.1-.3,1.4.1,1,.3,1.4,1.4.5.2,1.3-4.3-.1-4.2-.2-.5-.4-.5-1-2.1-.5-3.1.1-.4.5-.8.7-.6.5-.3.9-.3,4-.2,1-.6.8-.8h0l.4.5.7.3.9-.3.6.2,1-.7,2-.2,1.4.8,1.5.1,1-1.4,2-.1,1-.6h.5l1.1,1.2,1,.3,1.8-1,1.3.1,1.2.8.9,1.8.3,1,2.7,2.1.1.8-.1,1.2-.3.2.3,2.2-1.3.6-.6.9-1,.3-2.5.4-.3.6,2.5,3.7-.4.7-1.6.2-1.3,1.2.4,1.5.9,1.9v.5l-.5.6-.3,5.3,2.4,3.2,1,.8-.4,1.1-.9,1.5-.3,1h.5l1.5-.6h.5l1.7.9,1.4,2.4.2.8.1,1.4.2.2,1.3.5,1.5.7,1,.7,2,2.5v.4l.7,1.3,1.1,1.5v.8Z" />
                            </router-link>
                            <b-tooltip target="UZ-SU" custom-class="my-tooltip-class">{{ $t('message.Surkhandarya')
                            }}</b-tooltip>
                            <router-link to="/city/2" class="tashkent-region">
                                <path id="UZ-TO" title="обл. Ташкент" class="cls-1"
                                    d="M706.2,216.48l-.2-.4-.7-.5-.8-.4-3.3-3-.9-.5-1.8-.2-1.2-.7h-.5l-.9.2-1.1.5-1.3,1.2h-.7l-.9-.3h-.4l-1.8,2.2-1,.7-1,.4-1.2.9h-.7l-1.1-1-.5.2-.6.6-.7.7-.8,1.4-.8.7-.5.9-1,.8L679,222l-.2,1.3-.9,1.8-1.1,3v.2l-.2.5-.7.3h-.4l-1.2-1.1-.8-.2-.2-.6.1-1.6-.5-.9-2.5-1.4-2.7-2.4-.4-.2-.7.1-.4.5-.3,2.1-.2.4-1,.9-.3.7-1.6,1-.3.5.1,1.2.3,1.4-.1,1.1-1,.7-1,.3-.5.6h-.5l-1.2.6-.9,1.3-1.1.9-.4.8-.7,2-.6,1-3.2,1.6-1.3,1-.7,2.1-.3.3-.3.1-.4-.1-.2-.3v-.6l-.4-.7-.4-.1-.7.2-.3.3-1.7,4-2.9,1.2-1.2-1-.7-.3h-.5l-1.7,1.1-2,.3-.3-.1-.8.1-.3.2-.2.4-.5.5-.7.3-2.7.6-.5.2-1.2,1.1-.3.5-1,.7-1.3,1.4-.4.5-.5,1.6-.2.3-.7.4-1.2.4-.4-.1-.3.1-1.7,1.4-.7,1.1v.5l.3.5,1.2.8-.3,1-.4.2-2.2-.4-.5.2h-.8l-1.3.4h-.5l-1-.6-.6-.1-1.1.1-.4-.1-1.5.3-1.2.7-.6,1.9-.4.5-2.2,1.3-1.1,2.8-.7.5-.5-.1-.6-.6-.3-.1-.5.2-2,3.1-.2,2.7-.2.4-1.4,1.2-.3,1.8-.2.1-.8-.1-.7.5-.7.9-1.4,1.4-1.5,2-.7,1.1-.5,1.1-1.7,2.1-.7,1.7-.2,1.5-.2.4-1.3,1.2-1.8.7-1,.9h0l4.9,5.5,3.5,3.5,4.9,4.4,4.7,3.9.6.1,3,4.2-.5,4.7-.9,5.3-1,5v1.1l.1.6.5,1.1-.3,4.7h0l2.5.2h.6l1,.4,1.1-.1.8-.3,1.3.3h2l1.1.6.5-.4-.8-2.1-.4-.4-1.4-.3-.4-.4.2-.9-.3-.6.2-.6,1.8.2.8-.1,1.1-1.1v-.9l.3-.5V330l-1-.8-.4-.5v-.8l-.3-.8-.4-.4.2-.9-.5-.2-.6-2.1-.4-.5v-.8l.3-.4V321l-.1-.8-1.3-1.9-.1-.3.3-.6,1.6-1,1.8-.2.9.2.3-.1.3-.3v-.2l.4-.8.5-.2.3-1.3-.6-1.2-.3-1.1.2-3.5.1-.3.3-.4.2-1,1.8-2.6,1.6-.2.7.3,2.5.7,1.2.1.8.7.8,1.7.3,1.2.5.8,1.3.9.7.9.7.1.4.2.5,1.3.3.4.7.1,1.6-.1.9-.6,1.4-3,.5-.4.7-.2,1.4.4h.3l.9-1,1.1-.7h.4l1.6,1h.2l1.2-1.1.8-.5,2-.3.8-.4,1.1-.9,1.4-.6,2.4-2.3.3-.4.3-.9.5-.6.6-.1,1,.4,1.1.2,1.5-.9.9-.4.7-1,1.6-1h1.2l.7-.2.4-.4.5-1v-.4l-.3-.9.2-.7.7-.8V292l.3-.5-.3-1.3.1-.5.4-.3.4-.9.5-.6,1.3-.5,1,.3h0l-.2-.4.2-.9v-1.8l-.2-2.3-.7-1.3-1.9-2.6-.7-7.3,3-4.1.7-1.9h0l-.5-1-.5-.6-.8-.6-1.2-1.5-1.2-.1-.5-.5-.6-1.5-.4-.3-1.3-.6-1.1-.2-1,.1-.5.3-.8.1-.9-.2-1.3.1-.6-.4-.2-.4-.2-1.2.1-2,.3-.7.4-.6,1.3-.5.7-.1,1.3.1,1.7-1.5,1.3.1.8-.4,1.5-1.5.6-.9.3-.2,2.1-1.1.5-.2,1.7-1.1.7-1.3.1-2.2.2-.5.6-.6,1.2-.6,2.2-1.5.3-1.2,1.1-.8.4-.4.7-1.5,1-1.1,1.2-.6.7-.1.9.3h.4l.2-.2.2-.8.2-.2.7.5,1,.4h.9l.4-.1.9-.9.3-.5.2-1.8-.9-1.6.3-.9.7-.7.1-.7.2-.3.6-.3h.8l1.9,1,.8.2h.8l1-.5,1.3-1.1.7-.3,1.8-1.8.8-.3,2.7-2.6,1.1-.4h.8l1.3.3.4-.6.7-.5.5-.2.2-.3.1-1.6ZM636,271.66l-1.24,1.55.31,2.18h-1.24l-.62.31-.93,2.17v1.55l.31.93-.93.93-1.56,2.48,1.87,2.49.62,1.55v2.79l-.62,1.55-3.11,3.41-.93.62-1.86.31-1.24-.93-1.24-2.79.62-1.24L622,290.9l-3.42-.31-3.41,2.79v1.55l-1.86.31-2.17-.31-.62-.93-1.24.62h-.62l-.93-2.48-1.56-.93-.93.62-.93-.62-2.79-.62-.31-.93.31-4.66.31-2.79,1.55-4,.31-2.48,3.73-4h.31l.31.62,3.1.62,2.48-1.24.93-.93h.62l5,2.49,1.86-.32,1.55.94,1.24-2.18L627,272l2.17-2.48,1.86-.31,1.25-1.86,1.55-.31v2.17l1.55,1.55Z" />
                            </router-link>
                            <b-tooltip target="UZ-TO" custom-class="my-tooltip-class">{{ $t('message.Tashkent_reg')
                            }}</b-tooltip>
                            <router-link to="/city/1" class="tashkent-city">
                                <path id="UZ-TK" title="город Ташкент" class="cls-1"
                                    d="M634.09,268.25v-1.86l-.31-.31h-.62l-.93.93-.31,1.24-2.49.62-2.17,2.48-2.17-.31-1.24,2.17-1.55-.93-1.86.31-5-2.48h-.62l-.93.93-2.48,1.24-3.1-.62L608,271h-.31l-3.73,4-.31,2.79-1.55,4-.31,2.79-.31,4.66.31.93,2.79.62.93.62.94-.62,1.55.93.93,2.48h.62l1.24-.62.62.93,2.17.31,1.86-.31v-1.55l3.42-2.79,3.41.31,2.17.62-.62,1.24,1.24,2.79,1.24.93,1.86-.31,3.11-3.1,1.24-2.79-.31-3.72L631,284.07l-.93-.93,1.55-2.48.93-.93-.31-.93v-1.55l.93-2.17.62-.31,1.24.31-.31-2.18.93-.93.31-1.55-.31-.93H635Z" />
                            </router-link>
                            <b-tooltip target="UZ-TK" custom-class="my-tooltip-class">{{ $t('message.Tashkent_city')
                            }}</b-tooltip>
                            <router-link to="/city/13">
                                <path id="UZ-XO" title="Хорезм" class="cls-1"
                                    d="M283,312.68l-1.3-2.9-.5-.8-.7-.6-.3-.8-.2-2.8-.5-.7-.3-1-1.2-2-.1-1.2.2-1.2-.1-2-.1-.5-.3-2.9.2-1.6-.2-.4-.5-.2-.2-.7v-.6l-.3-.8-.7-.9-1.5-.8-.6-.1-.5-.3-.3-.6.2-.9-.4-1.1-.5-.9-1.2-.7-1.9-2-1.1-.3-1.5-1-2-2.4-.5-.3-1.3-.1-.7-.2-.5-.3-.4-.4-.3-1-.4-.7-.9-.6h-.5l-1.3.6-1.8-.1-.7-.2-1.6-.9-1.8-.3h-.5l-.5.3-.8,1.5.1,2.6-.4.8-.3,1.6-.4.9-.4.4-.5.3-1.1.2-.1.1-1.7.2-.3-.1h-1.3l-.2-.1-.3.1-.7-.2-3.1-1.5-2.1-2.2-.3-.1-2,.2-1.3-1.6-4.9-.2-.4.2-1-.1-2.2.3-2.6-.1-1.7.3H217l-4.8.3h-.9l-2.6.4-.9-.1-.7-.2-3.2-1.9-2.9-2.6-6.1-4.2-3.4-1.9-1.2-1-.6-1.2v-.7l.2-.8v-3l.3-1.9.4-.8,2.1-2,.3-.6v-1.2l-.3-.9-1.1-2-1.2-1.5-1.8-2.9-.4-1.5.5-1.2.6-2.3.2-.1h.3l.9.5h1l2,.7,1.1.5,1.3,1.1h1.2l.8.6.8.3.3-.4h.7l.3-.2v-.4l-.5-.7-1.1-.9-1.2-1.3-1.3-.6-1.7-.4-1.4-.9-.8-.8-.3-.7h0l2.7-5.2,1.9-.9,4.3-1.4,5.3,1.1.4.5.2.6v2.6l.4,2.4,3.1,5.4.4.5.7.6.7.3,5.2,4.8,3.4,3.9,1.6,1.5,8.2,7.3,6,4.5,1.4.6,2.2.4.7.3.7.6,2,2.3.4.9.3,1.2,2.3,1.4h1.5l.7-.8.5-1.9,1.2-2.3.8-.9,1.4-.8.6-.2h3l8.9,2.1,3.5,1.9,3.1,1.9,8,8.8,1.5,2.8,4.6,7.4.3.2.7.2,2.5-1.2h0l3.2,3.3,5.9,6.7.7,1.1v1.5l-.8,3.8-4.6,5.1-6.3,7.6h0Z" />
                            </router-link>
                            <b-tooltip target="UZ-XO" custom-class="my-tooltip-class">{{ $t('message.Khorezm')
                            }}</b-tooltip>
                        </g>
                    </g>
                </svg>
            </div>
        </div>

        <div class="container section-div" id="faqpart">
            <h1 class="section-head" data-aos="zoom-in" data-aos-duration="1500">{{ $t('message.faqfull') }} </h1>

            <div class="container contmaxwdth" style="height:300px; overflow:auto;" data-aos="fade-up"
                data-aos-duration="1500">
                <div role="tablist" class="faq_list">
                    <b-card no-body class="mb-1 topic-three" v-for="val in faq" :key="val.id">
                        <b-card-header header-tag="header" class="py-1" role="tab">
                            <div class="row">
                                <div class="col-10 pt-2 left p-2">
                                    <h6>{{ val['title_' + selectedLocale.suffix.toLowerCase()] }}</h6>
                                </div>
                                <div class="col-2 text-right pr-2">
                                    <button class="btn btn-light btn-modal" href="#" v-b-toggle="'accordion-' + val.id">{{
                                        $t('message.more_info') }}</button>
                                </div>
                            </div>
                        </b-card-header>
                        <b-collapse :id="'accordion-' + val.id" accordion="my-accordion" role="tabpanel">
                            <b-card-body>
                                <b-card-text>{{ val['body_' + selectedLocale.suffix.toLowerCase()] }}</b-card-text>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

            <hr style="width: 100%;">

        </div>

        <div class="container section-div" id="whatsgchpart" data-aos="fade-up" data-aos-duration="1000">
            <h1 class="section-head">{{ $t('message.news') }}</h1>
            <div style="display: block; margin-top: 1rem !important;">
                <div v-if="news.length === 0" class="text-center">
                    <img src="/static/images/nodatafound.png" width="100%" />
                    <h2 class="">{{ $t('message.notfound') }}</h2>
                </div>
                <carousel-news v-if="news.length > 0" :data="news"></carousel-news>
            </div>
        </div>
        <div class="container section-div" data-aos="fade-up" data-aos-duration="1000">
            <div class="row text-center pb-3">
                <div class="col-6 index_icons">
                    <img class="brand-img bsnav-brand-center responsive" src="/static/images/icons/active_projects.svg"
                        alt="" width="150">
                    <p class="index_object">{{ $t('message.realized_objects') }}<br> ({{ $t('message.count') }})</p>
                    <p class="count_object">{{ stats.allRealized }}</p>
                </div>
                <div class="col-6 index_icons">
                    <img class="brand-img bsnav-brand-center responsive" src="/static/images/icons/realized _projects.svg"
                        alt="" width="150">
                    <p class="index_object">{{ $t('message.active_objects') }} <br>({{ $t('message.count') }})</p>
                    <p class="count_object">{{ stats.activeObjects }}</p>
                </div>
            </div>
        </div>

        <footer>
            <div class="container sitemap text-center">
                <h2>{{ $t('message.site_map') }}</h2>
                <ul id="sitemapul">
                    <li class="nav-item"><router-link to="/about-part" class="nav-link">
                            {{ $t('message.about_management') }}</router-link></li>
                    <li class="nav-item"><a class="nav-link" href="#objectspart">{{ $t('message.ppp_objects') }}</a></li>
                    <li class="nav-item"><router-link to="/realized-objects" class="nav-link">
                            {{ $t('message.realized_objects') }}</router-link></li>
                    <li class="nav-item"><router-link to="/private-schools" class="nav-link">
                            {{ $t('message.private_schools') }}</router-link></li>
                    <li class="nav-item"><a class="nav-link" href="#faqpart">{{ $t('message.faq') }}</a></li>
                    <li class="nav-item"><router-link to="/contact-us" class="nav-link">
                            {{ $t('message.contact_us') }}</router-link></li>
                </ul>
                <hr>
                <h6>{{ $t('message.ministry_footer') }}<br>© 2023</h6>
            </div>
        </footer>

        <div class="webeonmark text-center">
            <h6>{{ $t('message.webeonmark') }} <a href="https://itsm.uz/"><img class="responsive m-2" width="35"
                        src="/static/images/itsm_logo.png" alt="" />ITSM.UZ</a></h6>
        </div>


        <!-- Modal -->
        <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
            aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel"></h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true"><img src="images/icons/close.png" alt=""></span>
                        </button>
                    </div>
                    <div class="modal-body"></div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Закрыть</button>
                        <!--<button type="button" class="btn btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import Carousel from '../../components/carousels.vue'
import CarouselNews from '../../components/carousels_news.vue'
import { getFaq, getCity, getRegion, getActiveSchools, getProposedSchools, getNews, getMainStat } from '../api/index'

import { mapGetters } from "vuex";

export default {
    name: 'indexPage',
    computed: {
        ...mapGetters(["selectedLocale", "languages"])
    },
    components: { Carousel, CarouselNews },
    data() {
        return {
            selected_proposed_region: null,
            selected_active_city: null,
            selected_active_region: null,
            selected_proposed_city: null,
            sorted_region_active: [],
            sorted_region_proposed: [],
            news: [],
            faq: [],
            school_active: [],
            school_proposed: [],
            city: [],
            region: [],
            stats: {},
            mobile_open: false
        }
    },
    watch: {
        selected_active_city: function (val) {
            this.selected_active_region = null
            this.sorted_region_active = this.region.filter(function (item) {
                return val * 1 === item.city_id * 1;
            })
        },
        selected_proposed_city: function (val) {
            this.selected_proposed_region = null
            this.sorted_region_proposed = this.region.filter(function (item) {
                return val * 1 === item.city_id * 1;
            })
        }
    },
    mounted() {
        if (this.languages.length > 3) {
            this.languages.splice(0, 3)
        }
        this.$i18n.locale = this.selectedLocale.suffix.toLowerCase();

        this.getMainData()
        this.fetchActiveSchools()
        this.fetchProposedSchools()
        this.fetchMainStats()
    },
    methods: {
        changeLanguage(language) {
            this.$i18n.locale = language.suffix.toLowerCase();
            this.$store.dispatch("changeLanguage", language);
        },
        getMainData() {
            getCity().then(res => {
                this.city = res.data
            })
            getRegion().then(res => {
                this.region = res.data
            })
            getNews().then(res => {
                this.news = res.data
            })
            getFaq().then(res => {
                this.faq = res.data
            })
        },
        fetchActiveSchools() {
            var reg = []
            if (!this.selected_active_region) {
                this.sorted_region_active.map(value => {
                    reg.push(value.id)
                })
            } else {
                reg = this.selected_active_region
            }
            var query = {
                region: reg.toString()
            }
            this.school_active = []

            if (this.sorted_region_active.length || !this.selected_active_city) {
                getActiveSchools(query).then(res => {
                    this.school_active = res.data
                })
            }
        },
        fetchProposedSchools() {
            var reg = []
            if (!this.selected_proposed_region) {
                this.sorted_region_proposed.map(value => {
                    reg.push(value.id)
                })
            } else {
                reg = this.selected_proposed_region
            }
            var query = {
                region: reg.toString()
            }
            this.school_proposed = []

            if (this.sorted_region_proposed.length || !this.selected_proposed_city) {
                getProposedSchools(query).then(res => {
                    this.school_proposed = res.data
                })
            }
        },
        fetchMainStats() {
            getMainStat().then(res => {
                this.stats = res.data[0]
            })
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cls-1 {
    fill: #ababab;
    stroke: #fff;
    stroke-width: 1.5px;
    border: solid 5px white;
    transition: 0.3s;
}

#UZ-TK {
    fill: #198ed0;
}

.cls-1:hover {
    fill: #198ed0;
    cursor: pointer;
}

/*.navbar {
      height: 110px;
    }*/

#aboutpart>>>.nav-link {
    font-size: 1.2rem;
    font-weight: 600;
}

.index_icons i {
    font-size: 10rem;
}

.index_object {
    padding: 0.75rem;
    font-size: 1.5rem;
    margin-bottom: 0;
    font-weight: 600;
}

.count_object {
    font-weight: 900;
    font-size: 2.5rem;
    color: #087bce;
}

.modal-body {
    overflow: auto;
    height: 400px !important;
}

.lang_icon {
    width: 26px;
    background: url('/static/images/icons/language.svg') 100% 100% / cover no-repeat;
    height: 26px;
    display: inline-grid;
    position: inherit;
}

.sticked.in .lang_icon {
    width: 26px;
    background: url('/static/images/icons/language_color.svg') 100% 100% / cover no-repeat;
    height: 26px;
    display: inline-grid;
    position: inherit;
}

.lang_suffix {
    display: inline-flex !important;
    position: inherit !important;
    top: -6px !important;
    padding-left: 5px !important;
}

.lang_mob {
    display: none;
}
</style>
<style>
.faq_list .card {
    border: none !important;
}

.faq_list .card .card-header {
    background-color: #fff !important;
}

.faq_list .card .card-body {
    background: whitesmoke;
    border-bottom-right-radius: 16px;
    border-bottom-left-radius: 16px;
}

.dropdown-toggle::after {
    display: inline-flex !important;
    position: inherit !important;
    top: -6px !important;
}

@media (max-width: 763px) {
    .lang_mob {
        position: absolute;
        display: initial !important;
        right: 0;
    }

    .lang_mob .dropdown-toggle {
        border-color: transparent;
        background-color: transparent;
    }

    .lang_mob .btn-secondary:not(:disabled):not(.disabled):active,
    .btn-secondary:not(:disabled):not(.disabled).active,
    .show>.btn-secondary.dropdown-toggle {
        border-color: transparent;
        background-color: transparent;
    }

    .lang_mob .btn-secondary:focus,
    .lang_mob .btn-secondary.focus {
        box-shadow: none;
    }
}

@media (max-width: 768px) and (min-width: 490px) {
    .index_object {
        font-size: 1rem !important;
    }
}

@media only screen and (max-width: 490px) {
    .index_object {
        font-size: 1rem !important;
    }

    .index_icons .brand-img {
        width: 100px;
    }
}

.sticked .lang_suffix {
    color: #087bce;
}

.sticked .dropdown-toggle::after {
    color: #087bce;
}</style>

